module.exports = __webpack_public_path__ + "static/media/emptystatement1.e24a11d5.png";